export default class Cache {

  static USER_DATA_KEY = 'user_data';
  static LOGIN_AS_MODEL_KEY = 'login_as_model_key';

  // static getUserProfilePic() {
  //   return localStorage.getItem('user_profile_pic');
  // }

  // static setUserProfilePic(value) {
  //   localStorage.setItem('user_profile_pic', value);
  // }

  // static deleteUserProfilePic() {
  //   localStorage.removeItem('user_profile_pic');
  // }

  static setUserData(value) {
    const raw = JSON.stringify(value);
    localStorage.setItem(Cache.USER_DATA_KEY, raw);
  }

  static getUserData() {
    const raw = localStorage.getItem(Cache.USER_DATA_KEY);
    return JSON.parse(raw);
  }

  static deleteUserData() {
    localStorage.removeItem(Cache.USER_DATA_KEY);
  }

  static setLoginAsModel() {
    const raw = JSON.stringify(true);
    localStorage.setItem(Cache.LOGIN_AS_MODEL_KEY, raw);
  }

  static getLoginAsModel() {
    const raw = localStorage.getItem(Cache.LOGIN_AS_MODEL_KEY);
    return JSON.parse(raw);
  }

  static deleteLoginAsModel() {
    localStorage.removeItem(Cache.LOGIN_AS_MODEL_KEY);
  }
  
}
